import { getGalleryIdForApi } from './galleryStorage';

/**
 * Guest REST path prefix. Pass explicit `galleryId` when outside React (e.g. token validation in GalleryLayout).
 */
export function guestApiPath(suffix, galleryIdParam) {
  const id =
    galleryIdParam !== undefined && galleryIdParam !== null && String(galleryIdParam).trim()
      ? String(galleryIdParam).trim()
      : getGalleryIdForApi();
  if (!id) {
    throw new Error(
      'Gallery id missing: open the correct /g/{galleryId} link, complete invite login, or set REACT_APP_GALLERY_ID for local dev only.'
    );
  }
  const encodedId = encodeURIComponent(id);
  return `/galleries/${encodedId}${suffix}`;
}
